import { StateCreator } from "zustand";

export interface CartDeliveryAddressSlice {
  addressName2: string | null;
  addressName3: string | null;
  street: string | null;
  zipCode: string | null;
  city: string | null;
  country: string | null;
  setAddressName2: (addressName2: string | null) => void;
  setAddressName3: (addressName3: string | null) => void;
  setStreet: (street: string | null) => void;
  setZipCode: (zipCode: string | null) => void;
  setCity: (city: string | null) => void;
  setCountry: (country: string | null) => void;
  resetCartDeliveryAddress: () => void;
}

export const createCartDeliveryAddressSlice: StateCreator<
  CartDeliveryAddressSlice
> = (set) => ({
  addressName2: null,
  addressName3: null,
  street: null,
  zipCode: null,
  city: null,
  country: null,
  setAddressName2: (addressName2) =>
    set({ addressName2: addressName2 || null }),
  setAddressName3: (addressName3) =>
    set({ addressName3: addressName3 || null }),
  setStreet: (street) => set({ street: street || null }),
  setZipCode: (zipCode) => set({ zipCode: zipCode || null }),
  setCity: (city) => set({ city: city || null }),
  setCountry: (country) => set({ country: country || null }),
  resetCartDeliveryAddress: () =>
    set({
      addressName2: null,
      addressName3: null,
      street: null,
      zipCode: null,
      city: null,
      country: null,
    }),
});
